import { useEffect, useRef, useState } from "react";
import { useReducedMotion } from "framer-motion";
import { formatPrice } from "@/lib/format";
import { cn } from "@/lib/utils";

// Il prezzo cambia con una transizione numerica (450ms, cubic out), non con un salto secco.
export function AnimatedPrice({ value, className = "", duration = 450, ...rest }) {
  const reduce = useReducedMotion();
  const [display, setDisplay] = useState(value);
  const prev = useRef(value);

  useEffect(() => {
    const from = prev.current;
    const to = value;
    prev.current = value;
    if (reduce || from == null || to == null || from === to) {
      setDisplay(to);
      return;
    }
    let raf;
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(Math.round(from + (to - from) * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
      else setDisplay(to);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [value, reduce, duration]);

  return (
    <span className={cn("font-mono tabular-nums", className)} {...rest}>
      {formatPrice(display)}
    </span>
  );
}
